/* tslint:disable */
/* eslint-disable */
/**
 * Vividi Dashboard API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DeviceStatusInformation,
    DeviceStatusInformationFromJSON,
    DeviceStatusInformationFromJSONTyped,
    DeviceStatusInformationToJSON,
} from './DeviceStatusInformation';

/**
 * 
 * @export
 * @interface DeviceStatusListResponse
 */
export interface DeviceStatusListResponse {
    /**
     * 
     * @type {{ [key: string]: DeviceStatusInformation; }}
     * @memberof DeviceStatusListResponse
     */
    status: { [key: string]: DeviceStatusInformation; };
}

export function DeviceStatusListResponseFromJSON(json: any): DeviceStatusListResponse {
    return DeviceStatusListResponseFromJSONTyped(json, false);
}

export function DeviceStatusListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeviceStatusListResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': (mapValues(json['status'], DeviceStatusInformationFromJSON)),
    };
}

export function DeviceStatusListResponseToJSON(value?: DeviceStatusListResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': (mapValues(value.status, DeviceStatusInformationToJSON)),
    };
}

